import { render, staticRenderFns } from "./indexfotter.vue?vue&type=template&id=71742396&scoped=true"
import script from "./indexfotter.vue?vue&type=script&lang=js"
export * from "./indexfotter.vue?vue&type=script&lang=js"
import style0 from "./indexfotter.vue?vue&type=style&index=0&id=71742396&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71742396",
  null
  
)

export default component.exports